import { useModals } from 'almanac-ui/Modal'
import { useCurrentUserProfile } from 'hooks/queries/users/useCurrentUserProfile'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQueryClient } from 'react-query'
import {
  backgroundColors,
  foregroundColors,
  identities,
  IdentityKey,
  ImageKey,
} from 'components/SecretIdentityModal/identities'
import { SecretIdentity as SecretIdentityType } from 'types'
import client from 'api/client'
import { SelectAvatarModal } from 'components/SecretIdentityModal/SelectAvatarModal'
import { ButtonProps } from 'blaze-ui/Button/Types'

export const useSelectAvatarButton = (props?: Pick<ButtonProps, 'isDisabled'>) => {
  const { data } = useCurrentUserProfile()
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()
  const { openModal, closeModal } = useModals()

  const onPress = () => {
    openModal(SelectAvatarModal, {
      onSelectImage: async (imageKey: ImageKey) => {
        if (!selectAvatar) return
        await selectAvatar(imageKey)
        closeModal()
      },
      onSkip: closeModal,
    })
  }

  const getRandomIdentity = () => {
    const keys = Object.keys(identities).filter(
      (key) => key !== (data?.secret_identity as SecretIdentityType).identity_key,
    )
    const randomKey = keys[Math.floor(Math.random() * keys.length)]
    return identities[randomKey as IdentityKey]
  }

  const selectAvatar = async (imageKey: ImageKey) => {
    if (!data?.id) return

    const newBackgroundColor: string = backgroundColors[Math.floor(Math.random() * (backgroundColors.length - 1))]
    const newForegroundColor: string = foregroundColors.filter((color) => color !== newBackgroundColor)[
      Math.floor(Math.random() * (foregroundColors.length - 1))
    ]

    await client.updateWorkspaceMemberProfile(workspaceId, data.id, {
      secret_identity: {
        identity_key: getRandomIdentity().key,
        hero_image_key: imageKey,
        foreground_color: newForegroundColor,
        background_color: newBackgroundColor,
      },
    })

    return queryClient.invalidateQueries(['user-profile'])
  }

  return {
    buttonProps: {
      onPress,
      isDisabled: !data?.id || props?.isDisabled,
      size: 'lg',
      variant: 'secondary',
    } as Required<Pick<ButtonProps, 'onPress' | 'isDisabled' | 'size' | 'variant'>>,
  }
}
